module.exports = "/legacy/23e6259a15a810f17379d797b29bbba1.svg";